import React from "react"
import {useState, useEffect} from "react"
import { PageProps, Link, graphql } from "gatsby"
import Img from "gatsby-image"


import Image from "../components/image"
import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm } from "../utils/typography"
import thumb_shop from "../../content/assets/thumb_shop.png"
import thumb_item from "../../content/assets/thumb_item.png"

type Data = {
    site: {
        siteMetadata: {
            title: string
        }
    }
    allInternalShops: {
        nodes: [{
            id: string
            timestamp: string
            shopname: string
            description: string
            url: string
            icon_url: string
            twitter_url: string
        }]
    }
    allMarkdownRemark: {
        edges: {
            node: {
                excerpt: string
                frontmatter: {
                    title: string
                    date: string
                    description: string
                }
                fields: {
                    slug: string
                }
            }
        }[]
    }
}

const Item  = ({ data, location }: PageProps<Data>) => {
    const siteTitle = data.site.siteMetadata.title
    const shops = data.allInternalShops.nodes;
    const items = data.allInternalItems.nodes;

    return (
        <Layout location={location} title={siteTitle}>
        <SEO title={siteTitle} />
        <main className="catalog">
        <h2>カタログ</h2>

        <div className="switch_btn">
        <p className="btn">アイテム</p>
        <a href="/catalog"><p className="btn">ショップ</p></a>
        </div>

        {/*
        <div className="tag">
        <p className="btn">全て</p>
        <a href="#"><p className="btn">新作</p></a>
        <a href="#"><p className="btn">セール中</p></a>
        <a href="#"><p className="btn">女性向け</p></a>
        <a href="#"><p className="btn">男性向け</p></a>
        <a href="#"><p className="btn">お仕事向け</p></a>
        <a href="#"><p className="btn">R-18</p></a>
        <a href="#"><p className="btn">服</p></a>
        <a href="#"><p className="btn">靴</p></a>
        <a href="#"><p className="btn">肌</p></a>
        <a href="#"><p className="btn">瞳</p></a>
        <a href="#"><p className="btn">服</p></a>
        <a href="#"><p className="btn">つめあわせ</p></a>
        <a href="#"><p className="btn">その他</p></a>
        </div>
        */}

        <div className="catalog_box">
        <ul className="item_catalog">
        {items.map((item, i) => {
            if (item === undefined) {
                return
            }
            var shop = null;
            shops.forEach((s) => {
                if (s.shopname == item.shopname) {
                    shop = s;
                }
            });
            var shoppath = item.shopname.replace(/[ \/]/g, "_");
            var shopimage = shoppath + "_shopimage.png";
            var shopitem1 = shoppath + "_item1_image.png";
            var shopitem2 = shoppath + "_item2_image.png";
            var shopitem3 = shoppath + "_item3_image.png";
            var items = [];
            if (item.item1_name != "") {
                    items.push((
                    <li key="0">
                    <a href={/catalog/+shoppath} className="shoplink">
                    <Image filename={shopimage} className="thumb"width="50" height="50" />
                    <p>{item.shopname}</p>
                    </a>
                    <a href={item.item1_url} target="_blank" className="itemlink">
                    <Image filename={shopitem1} width="380" height="213" />
                    </a>
                    </li>
                ));
            }
            if (item.item2_name != "") {
                    items.push((
                    <li key="0">
                        <a href={/catalog/+shoppath} className="shoplink">
                        <Image filename={shopimage} className="thumb"width="50" height="50" />
                        <p>{item.shopname}</p>
                        </a>
                        <a href={item.item2_url} target="_blank" className="itemlink">
                        <Image filename={shopitem2} width="380" height="213" />
                        </a>
                    </li>
                ));
            }
            if (item.item3_name != "") {
                    items.push((
                    <li key="2">
                        <a href={/catalog/+shoppath} className="shoplink">
                        <Image filename={shopimage} className="thumb"width="50" height="50" />
                        <p>{item.shopname}</p>
                        </a>
                        <a href={item.item3_url} target="_blank" className="itemlink">
                        <Image filename={shopitem3} width="380" height="213" />
                        </a>
                    </li>
                ));
            }
            return items;
        })}
        </ul>
        </div>
        </main>
        </Layout>
    )
}

export default Item 

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allInternalShops
    (
      filter: {id: {ne: "dummy"}}
      sort: { fields: [timestamp], order: DESC }
      limit: 1000
    ) {
      nodes {
        id
        timestamp
        shopname
        description
        url
        icon_url
        twitter_url
      }
    }
    allInternalItems
    (
      filter: {id: {ne: "dummy"}}
      sort: { fields: [timestamp], order: DESC }
      limit: 1000
    ) {
      nodes {
        id
        shopname
        item1_description
        item1_name
        item1_image
        item1_price
        item1_short_description
        item1_tag
        item1_url
        item2_description
        item2_image
        item2_name
        item2_price
        item2_short_description
        item2_tag
        item2_url
        item3_description
        item3_image
        item3_name
        item3_price
        item3_short_description
        item3_tag
        item3_url
        timestamp
      }
    }
  }
`
